// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3t87l","boxTitle":"Qualiphy_boxTitle__3AENo","box":"Qualiphy_box__3x3zD","toggleWrap":"Qualiphy_toggleWrap__3gqhZ"};